export var ViewportSize;
(function (ViewportSize) {
    ViewportSize["EXTRA_LARGE"] = "EXTRA_LARGE";
    ViewportSize["LARGE"] = "LARGE";
    ViewportSize["MEDIUM"] = "MEDIUM";
    ViewportSize["SMALL"] = "SMALL";
    ViewportSize["EXTRA_SMALL"] = "EXTRA_SMALL";
})(ViewportSize || (ViewportSize = {}));
export var ViewportSizeDefault;
(function (ViewportSizeDefault) {
    ViewportSizeDefault[ViewportSizeDefault["VIEWPORT_HEIGHT"] = 790] = "VIEWPORT_HEIGHT";
    ViewportSizeDefault[ViewportSizeDefault["VIEWPORT_WIDTH"] = 615] = "VIEWPORT_WIDTH";
})(ViewportSizeDefault || (ViewportSizeDefault = {}));
//# sourceMappingURL=ViewportSize.js.map